import { Home } from '@mui/icons-material';
import { Box, Button, Container, Typography, Divider, Grid, Paper } from '@mui/material';
import { FC, useEffect } from 'react';
import DisplayField from '@acorn-portal/shared/src/components/displayField';
import { useNavigate } from 'react-router';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';

const CancelledPolicy: FC = () => {
	const payNow = useAppSelector((redux) => redux.payNow);
	const navigate = useNavigate();
	useEffect(() => {
		if (!payNow.details) {
			navigate(ROUTE_PATHS.home);
		}
	}, []);
	const { details } = payNow;
	const homeHref =
		import.meta.env.VITE_AUTH_REALM === 'StreetCover' ? 'https://streetcover.co.uk' : 'https://acorninsure.co.uk';

	const handleGoBack = () => {
		navigate(ROUTE_PATHS.home);
	};

	return (
		<Paper
			elevation={1}
			sx={{
				margin: 1.5,
				borderRadius: '8px',
				paddingBottom: 3,
			}}
		>
			<Container maxWidth='sm'>
				<Box sx={{ padding: 2 }} />
				<Typography variant='h4' component='h4' color='secondary' sx={{ textAlign: 'center' }}>
					Policy Cancelled
				</Typography>
				<br />
				<Box my={2}>
					<Grid container spacing={1}>
						<Grid size={{ xs: 10, md: 12 }}>
							<DisplayField label='Policy Holder'>
								{details?.policyHolderFirstName} {details?.policyHolderLastName}
							</DisplayField>
						</Grid>
						<Grid size={{ xs: 10, md: 12 }}>
							<DisplayField label='Policy Number'>{details?.policyReference}</DisplayField>
						</Grid>
					</Grid>
					<Typography>
						Unfortunately your policy has been cancelled, if you wish to contact us further please use the webchat
						option available on our{' '}
						<a href={homeHref} target='_blank' rel='noreferrer'>
							main website
						</a>
					</Typography>
				</Box>
				<Divider sx={{ borderColor: 'rgb(109, 109, 109)' }} />
				<Grid size={{ xs: 10, md: 12 }} paddingTop={5} paddingBottom={5}>
					<Button
						variant='contained'
						color='primary'
						onClick={handleGoBack}
						startIcon={<Home />}
						size='large'
						fullWidth
					>
						Go Back
					</Button>
				</Grid>
			</Container>
		</Paper>
	);
};
export default CancelledPolicy;
